import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { maxLength, minLength, numeric, required } from 'vuelidate/lib/validators';
import { FIB } from "../../config/constants";
var POST_NAVIGATION_DELAY = FIB.POST_NAVIGATION_DELAY;
export default {
  name: 'Member',
  props: {
    value: {
      type: Boolean
    },
    persistent: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      error: false,
      errorMsg: null,
      pin: null
    };
  },
  computed: {
    getMemberFromPin: get('manageTeam/getMemberFromPin')
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.commit('app/SET_PAGE_LOADING', true);

                setTimeout(function () {
                  // Get team member from pin
                  Logger.debug('Check PIN');

                  var member = _this.getMemberFromPin(_this.pin); // Invalid pin (no matching team member)


                  if (!member) {
                    Logger.debug('Invalid PIN');
                    _this.error = true;
                    _this.errorMsg = _this.$t('staff.errorInvalidPin'); // need to stop the loader as the call has failed on the invalid pin

                    _this.$store.commit('app/SET_PAGE_LOADING', false);

                    return;
                  } // Inactive user


                  if (!member.status) {
                    Logger.debug('Inactive user');
                    _this.error = true;
                    _this.errorMsg = _this.$t('staff.errorInactive'); // need to stop the loader as the call has failed on the user active status

                    _this.$store.commit('app/SET_PAGE_LOADING', false);

                    return;
                  } // Allow team member login


                  Logger.debug('Valid PIN');
                  _this.pin = null;

                  _this.$store.set('settings/loggedInMember', member.id);

                  _this.$emit('done', {
                    name: 'member',
                    result: true
                  });
                }, POST_NAVIGATION_DELAY);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  validations: {
    pin: {
      maxLength: maxLength(5),
      minLength: minLength(3),
      numeric: numeric,
      required: required
    },
    validationGroup: ['pin']
  }
};